// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after { box-sizing: border-box; }

body {
    background-image: -webkit-radial-gradient(#ddd 1px,transparent 0),-webkit-radial-gradient(#ddd 1px,transparent 0);
    background-size: 50px 50px;

    margin: 0;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    font-variant: tabular-nums;
    line-height: 1.5715;
    background-color: #fff;
    font-feature-settings: 'tnum';
    height:100vh;
}

h1, h2, h3, h4, h5, h6 {
    margin-bottom: 0.5em;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
}


a, area, button, [role='button'], input:not([type='range']), label, select, summary, textarea {
    touch-action: manipulation;
}
a {
    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    transition: color 0.3s;
    -webkit-text-decoration-skip: objects;
}

.red { color: #d1242f; }

.header {
    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.02) 0px 2px 4px 0px, rgba(0, 0, 0, 0.06) 0px -1px 0px 0px inset;
    height: 50px;
    background: #FFFFFF;
    margin-bottom: 30px;
}

.flex {
    display: flex;
}

.header .header-left {
    flex-grow: 1;
}

.header .header-left h1{
    font-size: 23px;
    font-weight: bold;
    line-height: 30px;
    margin-bottom: 0px;
}

.header .header-left .title-caption{
    font-size: 12px;
    line-height: 14px;
}

.header .header-right {
    width: 400px;
    line-height: 50px;
    text-align: right;
}

.button {
    box-shadow: rgba(31, 35, 40, 0.04) 0px 1px 0px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px 0px inset;
    border: 1px solid rgba(201, 208, 215, 0.824);
    padding: 7px;
    color: rgb(101, 109, 118);
    border-radius: 5px;
    -webkit-user-select: none;
            user-select: none;
}

.button:hover {
    background: rgba(208, 215, 222, 0.32);
}

.button:active {
    background: rgba(208, 215, 222, 0.48);
}

.button.primary {
    color: #FFFFFF;
    background: #1890ff;
}

.icon {
    display: inline-block;
    color: inherit;
    font-style: normal;
    line-height: 0;
    text-align: center;
    text-transform: none;
    vertical-align: -0.125em;
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
}

.container {
    width: 80%;
    margin: 0px auto;
}

.list {
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
}

.list-item {
    cursor: pointer;
    padding: 7px;
}

.list-item:hover {
    background: rgba(208, 215, 222, 0.32);
}

.list-item.selected {
    background: rgba(208, 215, 222, 0.32);
}

/*
.container h1 {
    padding-top: 50px;
    text-align: center;
    font-weight: bold;
}
*/

.prompt-builder {
    padding: 10px;
    border-radius: 10px;
    background: #fce2ae;
    font-size: 20px;
    color: #333333;
    border: 1px solid #dec799;
    -webkit-user-select: none;
            user-select: none;
    margin-bottom: 0.5em;
}

.prompt-builder a {
    color: #000033;
    font-weight: bold;
    text-decoration: underline;
    text-decoration-style: dotted
}

.search-input {
    border: 1px solid #d9d9d9;
    border-radius: 2px;
}

.search-input:focus, .search-input:active {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);
    border-right-width: 1px;
    outline: 0;
}

.ready-prompt {
    padding: 10px;
    border-radius: 10px;
    background: #f0f4f9;
    color: #333333;
    white-space: pre-wrap;
}

[contenteditable] {
    border: 0px;
    /*padding:12px;*/
}
[data-placeholder]:empty:before {
     content: attr(data-placeholder);
     color: #888;
     font-style: italic;
}

.editable-variable {
    display: inline-block;
    outline: none;
    cursor: pointer;

    color: #000033;
    font-weight: bold;
    text-decoration: underline;
    text-decoration-style: dotted
}

.var-menu {
}

.var-menu-item-wrapper {
    max-height: 350px;
    overflow-y: auto;
}

.var-menu .var-menu-item {
    position: relative;
    padding: 5px;
    cursor: pointer;
}
.var-menu .var-menu-item:hover {
    background: #EFEFEF;
}

.var-menu .var-menu-item.selected,
.var-menu .var-menu-item:hover.selected {
    color: #FFFFFF;
    background: #1890ff;
}

.modal {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.modal .modal-header {
    padding: 30px 30px 0 30px;
    background: rgb(246, 248, 250);
    box-shadow: rgb(208, 215, 222) 0px -1px 0px 0px inset;
}

.modal .modal-body {
    flex-grow: 1;
    padding: 0px 30px;
    overflow: auto;
}

.modal .modal-footer {
    padding: 30px 30px 30px 30px;
}


.template-builder {
}

.template-builder h3 {
    font-weight: bold;
}

input, .template-builder input{
    outline: none;
    padding: 7px;
    border-radius: 7px;
    border: 1px solid #DFDFDF;
}

.template-builder textarea{
    outline: none;
    padding: 7px;
    border-radius: 7px;
    border: 1px solid #DFDFDF;
}

.template-builder .title {
    color: #1f2328;
    font-weight: bold;
    margin-top: 21px;
    margin-bottom: 3px;
}

.template-builder .tabs {
    align-items: center;
    display: flex;
    list-style: none !important;
    padding-left: 0;
    margin-bottom: 0;
    gap: 15px;
    -webkit-user-select: none;
            user-select: none;
}

.template-builder .tabs .tab-item button {
    background: none;
    position: relative;
    text-align: center;
    color: rgb(31, 35, 40);
    padding: 5px 10px;
    border-radius: 7px;
    border: 0px;
    cursor: pointer;
    font-size: 14px;
}


.template-builder .tabs .tab-item button:focus {
  outline: 1px solid #1890ff;
}

.template-builder .tabs .tab-item button:active {
  outline: none;  
}


.template-builder .tabs .tab-item:hover button {
    background: rgba(208, 215, 222, 0.32);
    transition: background .12s ease-out;
}


.template-builder .tabs .tab-item button.selected {
    font-weight: bold;
}

.template-builder .tabs .tab-item button.selected:after {
    position: absolute;
    background: #1890ff;
    border-radius: 6px;
    transform: translate(50%, -50%);
    right: 50%;
    width: 100%;
    bottom: calc(50% - 25px);
    content: "";
    height: 2px;
}


.ant-row {
    margin-bottom: 7px;
}

.ant-dropdown-menu {
    padding: 0;
}


.ant-dropdown-menu-item.ant-dropdown-menu-item-danger {
  color: #ff4d4f;
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-danger:hover {
  color: #fff;
  background-color: #ff4d4f;
}
.ant-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  display: block;
}
.ant-dropdown::before {
  position: absolute;
  top: -4px;
  right: 0;
  bottom: -4px;
  left: -7px;
  z-index: -9999;
  opacity: 0.0001;
  content: ' ';
}
.ant-dropdown-wrap {
  position: relative;
}
.ant-dropdown-wrap .ant-btn > .anticon-down {
  font-size: 10px;
}
.ant-dropdown-wrap .anticon-down::before {
  transition: transform 0.2s;
}
.ant-dropdown-wrap-open .anticon-down::before {
  transform: rotate(180deg);
}
.ant-dropdown-hidden,
.ant-dropdown-menu-hidden,
.ant-dropdown-menu-submenu-hidden {
  display: none;
}

.rc-dropdown, .rc-trigger-popup {
    position: absolute;
    background: #FFFFFF;
    box-shadow: 1px 2px 3px rgba(0,0,0, 0.3);
    border-radius: 5px;
    border: 1px solid #EFEFEF;
}

.rc-dropdown-hidden, .rc-trigger-popup-hidden {
    display: none;
}


.ReactModal__Overlay {
    opacity: 0;
    transition: opacity 200ms ease-in-out;
}

.ReactModal__Overlay--after-open{
    opacity: 1;
}

.ReactModal__Overlay--before-close{
    opacity: 0;
}





.react-grid-layout {
  position: relative;
  transition: height 200ms ease;
}
.react-grid-item {
  transition: all 200ms ease;
  transition-property: left, top, width, height;
}
.react-grid-item img {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
.react-grid-item.cssTransforms {
  transition-property: transform, width, height;
}
.react-grid-item.resizing {
  transition: none;
  z-index: 1;
  will-change: width, height;
}

.react-grid-item.react-draggable-dragging {
  transition: none;
  z-index: 3;
  will-change: transform;
}

.react-grid-item.dropping {
  visibility: hidden;
}

.react-grid-item.react-grid-placeholder {
  background: white;
  opacity: 0.2;
  transition-duration: 100ms;
  z-index: 2;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.react-grid-item.react-grid-placeholder.placeholder-resizing {
  transition: none;
}

.react-grid-item > .react-resizable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
}

.react-grid-item > .react-resizable-handle::after {
  content: "";
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 5px;
  height: 5px;
  border-right: 2px solid rgba(0, 0, 0, 0.4);
  border-bottom: 2px solid rgba(0, 0, 0, 0.4);
}

.react-resizable-hide > .react-resizable-handle {
  display: none;
}

.react-grid-item > .react-resizable-handle.react-resizable-handle-sw {
  bottom: 0;
  left: 0;
  cursor: sw-resize;
  transform: rotate(90deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-se {
  bottom: 0;
  right: 0;
  cursor: se-resize;
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-nw {
  top: 0;
  left: 0;
  cursor: nw-resize;
  transform: rotate(180deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-ne {
  top: 0;
  right: 0;
  cursor: ne-resize;
  transform: rotate(270deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-w,
.react-grid-item > .react-resizable-handle.react-resizable-handle-e {
  top: 50%;
  margin-top: -10px;
  cursor: ew-resize;
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-w {
  left: 0;
  transform: rotate(135deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-e {
  right: 0;
  transform: rotate(315deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-n,
.react-grid-item > .react-resizable-handle.react-resizable-handle-s {
  left: 50%;
  margin-left: -10px;
  cursor: ns-resize;
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-n {
  top: 0;
  transform: rotate(225deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-s {
  bottom: 0;
  transform: rotate(45deg);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yBAAyB,sBAAsB,EAAE;;AAEjD;IACI,iHAAiH;IACjH,0BAA0B;;IAE1B,SAAS;IACT,0BAA0B;IAC1B,eAAe;IACf,kMAAkM;IAClM,0BAA0B;IAC1B,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,gBAAgB;AACpB;;;AAGA;IACI,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA,OAAO,cAAc,EAAE;;AAEvB;IACI,+JAA+J;IAC/J,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mGAAmG;IACnG,4CAA4C;IAC5C,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,wBAAwB;IACxB,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;;;;;CAMC;;AAED;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;IAC3C,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;KACK,+BAA+B;KAC/B,WAAW;KACX,kBAAkB;AACvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,eAAe;;IAEf,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B;AACJ;;AAEA;AACA;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,qDAAqD;AACzD;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;;AAGA;AACA;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;;AAGA;IACI,qCAAqC;IACrC,oCAAoC;AACxC;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;IACV,WAAW;IACX,wBAAwB;IACxB,WAAW;IACX,WAAW;AACf;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;;AAGA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,aAAa;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;;;;;AAMA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,UAAU;EACV,yBAAyB;EAGzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,MAAM;EACN,OAAO;EACP,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;;EAEE,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,yBAAyB;AAC3B;AACA;;EAEE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,MAAM;EACN,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,wBAAwB;AAC1B","sourcesContent":["*, *::before, *::after { box-sizing: border-box; }\n\nbody {\n    background-image: -webkit-radial-gradient(#ddd 1px,transparent 0),-webkit-radial-gradient(#ddd 1px,transparent 0);\n    background-size: 50px 50px;\n\n    margin: 0;\n    color: rgba(0, 0, 0, 0.85);\n    font-size: 14px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n    font-variant: tabular-nums;\n    line-height: 1.5715;\n    background-color: #fff;\n    font-feature-settings: 'tnum';\n    height:100vh;\n}\n\nh1, h2, h3, h4, h5, h6 {\n    margin-bottom: 0.5em;\n    color: rgba(0, 0, 0, 0.85);\n    font-weight: 500;\n}\n\n\na, area, button, [role='button'], input:not([type='range']), label, select, summary, textarea {\n    touch-action: manipulation;\n}\na {\n    color: #1890ff;\n    text-decoration: none;\n    background-color: transparent;\n    outline: none;\n    cursor: pointer;\n    transition: color 0.3s;\n    -webkit-text-decoration-skip: objects;\n}\n\n.red { color: #d1242f; }\n\n.header {\n    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.02) 0px 2px 4px 0px, rgba(0, 0, 0, 0.06) 0px -1px 0px 0px inset;\n    height: 50px;\n    background: #FFFFFF;\n    margin-bottom: 30px;\n}\n\n.flex {\n    display: flex;\n}\n\n.header .header-left {\n    flex-grow: 1;\n}\n\n.header .header-left h1{\n    font-size: 23px;\n    font-weight: bold;\n    line-height: 30px;\n    margin-bottom: 0px;\n}\n\n.header .header-left .title-caption{\n    font-size: 12px;\n    line-height: 14px;\n}\n\n.header .header-right {\n    width: 400px;\n    line-height: 50px;\n    text-align: right;\n}\n\n.button {\n    box-shadow: rgba(31, 35, 40, 0.04) 0px 1px 0px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px 0px inset;\n    border: 1px solid rgba(201, 208, 215, 0.824);\n    padding: 7px;\n    color: rgb(101, 109, 118);\n    border-radius: 5px;\n    user-select: none;\n}\n\n.button:hover {\n    background: rgba(208, 215, 222, 0.32);\n}\n\n.button:active {\n    background: rgba(208, 215, 222, 0.48);\n}\n\n.button.primary {\n    color: #FFFFFF;\n    background: #1890ff;\n}\n\n.icon {\n    display: inline-block;\n    color: inherit;\n    font-style: normal;\n    line-height: 0;\n    text-align: center;\n    text-transform: none;\n    vertical-align: -0.125em;\n    text-rendering: optimizelegibility;\n    -webkit-font-smoothing: antialiased;\n}\n\n.container {\n    width: 80%;\n    margin: 0px auto;\n}\n\n.list {\n    list-style: none;\n    padding-left: 0;\n    margin-bottom: 0;\n}\n\n.list-item {\n    cursor: pointer;\n    padding: 7px;\n}\n\n.list-item:hover {\n    background: rgba(208, 215, 222, 0.32);\n}\n\n.list-item.selected {\n    background: rgba(208, 215, 222, 0.32);\n}\n\n/*\n.container h1 {\n    padding-top: 50px;\n    text-align: center;\n    font-weight: bold;\n}\n*/\n\n.prompt-builder {\n    padding: 10px;\n    border-radius: 10px;\n    background: #fce2ae;\n    font-size: 20px;\n    color: #333333;\n    border: 1px solid #dec799;\n    user-select: none;\n    margin-bottom: 0.5em;\n}\n\n.prompt-builder a {\n    color: #000033;\n    font-weight: bold;\n    text-decoration: underline;\n    text-decoration-style: dotted\n}\n\n.search-input {\n    border: 1px solid #d9d9d9;\n    border-radius: 2px;\n}\n\n.search-input:focus, .search-input:active {\n    border-color: #40a9ff;\n    box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);\n    border-right-width: 1px;\n    outline: 0;\n}\n\n.ready-prompt {\n    padding: 10px;\n    border-radius: 10px;\n    background: #f0f4f9;\n    color: #333333;\n    white-space: pre-wrap;\n}\n\n[contenteditable] {\n    border: 0px;\n    /*padding:12px;*/\n}\n[data-placeholder]:empty:before {\n     content: attr(data-placeholder);\n     color: #888;\n     font-style: italic;\n}\n\n.editable-variable {\n    display: inline-block;\n    outline: none;\n    cursor: pointer;\n\n    color: #000033;\n    font-weight: bold;\n    text-decoration: underline;\n    text-decoration-style: dotted\n}\n\n.var-menu {\n}\n\n.var-menu-item-wrapper {\n    max-height: 350px;\n    overflow-y: auto;\n}\n\n.var-menu .var-menu-item {\n    position: relative;\n    padding: 5px;\n    cursor: pointer;\n}\n.var-menu .var-menu-item:hover {\n    background: #EFEFEF;\n}\n\n.var-menu .var-menu-item.selected,\n.var-menu .var-menu-item:hover.selected {\n    color: #FFFFFF;\n    background: #1890ff;\n}\n\n.modal {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.modal .modal-header {\n    padding: 30px 30px 0 30px;\n    background: rgb(246, 248, 250);\n    box-shadow: rgb(208, 215, 222) 0px -1px 0px 0px inset;\n}\n\n.modal .modal-body {\n    flex-grow: 1;\n    padding: 0px 30px;\n    overflow: auto;\n}\n\n.modal .modal-footer {\n    padding: 30px 30px 30px 30px;\n}\n\n\n.template-builder {\n}\n\n.template-builder h3 {\n    font-weight: bold;\n}\n\ninput, .template-builder input{\n    outline: none;\n    padding: 7px;\n    border-radius: 7px;\n    border: 1px solid #DFDFDF;\n}\n\n.template-builder textarea{\n    outline: none;\n    padding: 7px;\n    border-radius: 7px;\n    border: 1px solid #DFDFDF;\n}\n\n.template-builder .title {\n    color: #1f2328;\n    font-weight: bold;\n    margin-top: 21px;\n    margin-bottom: 3px;\n}\n\n.template-builder .tabs {\n    align-items: center;\n    display: flex;\n    list-style: none !important;\n    padding-left: 0;\n    margin-bottom: 0;\n    gap: 15px;\n    user-select: none;\n}\n\n.template-builder .tabs .tab-item button {\n    background: none;\n    position: relative;\n    text-align: center;\n    color: rgb(31, 35, 40);\n    padding: 5px 10px;\n    border-radius: 7px;\n    border: 0px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n\n.template-builder .tabs .tab-item button:focus {\n  outline: 1px solid #1890ff;\n}\n\n.template-builder .tabs .tab-item button:active {\n  outline: none;  \n}\n\n\n.template-builder .tabs .tab-item:hover button {\n    background: rgba(208, 215, 222, 0.32);\n    transition: background .12s ease-out;\n}\n\n\n.template-builder .tabs .tab-item button.selected {\n    font-weight: bold;\n}\n\n.template-builder .tabs .tab-item button.selected:after {\n    position: absolute;\n    background: #1890ff;\n    border-radius: 6px;\n    transform: translate(50%, -50%);\n    right: 50%;\n    width: 100%;\n    bottom: calc(50% - 25px);\n    content: \"\";\n    height: 2px;\n}\n\n\n.ant-row {\n    margin-bottom: 7px;\n}\n\n.ant-dropdown-menu {\n    padding: 0;\n}\n\n\n.ant-dropdown-menu-item.ant-dropdown-menu-item-danger {\n  color: #ff4d4f;\n}\n.ant-dropdown-menu-item.ant-dropdown-menu-item-danger:hover {\n  color: #fff;\n  background-color: #ff4d4f;\n}\n.ant-dropdown {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5715;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  display: block;\n}\n.ant-dropdown::before {\n  position: absolute;\n  top: -4px;\n  right: 0;\n  bottom: -4px;\n  left: -7px;\n  z-index: -9999;\n  opacity: 0.0001;\n  content: ' ';\n}\n.ant-dropdown-wrap {\n  position: relative;\n}\n.ant-dropdown-wrap .ant-btn > .anticon-down {\n  font-size: 10px;\n}\n.ant-dropdown-wrap .anticon-down::before {\n  transition: transform 0.2s;\n}\n.ant-dropdown-wrap-open .anticon-down::before {\n  transform: rotate(180deg);\n}\n.ant-dropdown-hidden,\n.ant-dropdown-menu-hidden,\n.ant-dropdown-menu-submenu-hidden {\n  display: none;\n}\n\n.rc-dropdown, .rc-trigger-popup {\n    position: absolute;\n    background: #FFFFFF;\n    box-shadow: 1px 2px 3px rgba(0,0,0, 0.3);\n    border-radius: 5px;\n    border: 1px solid #EFEFEF;\n}\n\n.rc-dropdown-hidden, .rc-trigger-popup-hidden {\n    display: none;\n}\n\n\n.ReactModal__Overlay {\n    opacity: 0;\n    transition: opacity 200ms ease-in-out;\n}\n\n.ReactModal__Overlay--after-open{\n    opacity: 1;\n}\n\n.ReactModal__Overlay--before-close{\n    opacity: 0;\n}\n\n\n\n\n\n.react-grid-layout {\n  position: relative;\n  transition: height 200ms ease;\n}\n.react-grid-item {\n  transition: all 200ms ease;\n  transition-property: left, top, width, height;\n}\n.react-grid-item img {\n  pointer-events: none;\n  user-select: none;\n}\n.react-grid-item.cssTransforms {\n  transition-property: transform, width, height;\n}\n.react-grid-item.resizing {\n  transition: none;\n  z-index: 1;\n  will-change: width, height;\n}\n\n.react-grid-item.react-draggable-dragging {\n  transition: none;\n  z-index: 3;\n  will-change: transform;\n}\n\n.react-grid-item.dropping {\n  visibility: hidden;\n}\n\n.react-grid-item.react-grid-placeholder {\n  background: white;\n  opacity: 0.2;\n  transition-duration: 100ms;\n  z-index: 2;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n}\n\n.react-grid-item.react-grid-placeholder.placeholder-resizing {\n  transition: none;\n}\n\n.react-grid-item > .react-resizable-handle {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n}\n\n.react-grid-item > .react-resizable-handle::after {\n  content: \"\";\n  position: absolute;\n  right: 3px;\n  bottom: 3px;\n  width: 5px;\n  height: 5px;\n  border-right: 2px solid rgba(0, 0, 0, 0.4);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n}\n\n.react-resizable-hide > .react-resizable-handle {\n  display: none;\n}\n\n.react-grid-item > .react-resizable-handle.react-resizable-handle-sw {\n  bottom: 0;\n  left: 0;\n  cursor: sw-resize;\n  transform: rotate(90deg);\n}\n.react-grid-item > .react-resizable-handle.react-resizable-handle-se {\n  bottom: 0;\n  right: 0;\n  cursor: se-resize;\n}\n.react-grid-item > .react-resizable-handle.react-resizable-handle-nw {\n  top: 0;\n  left: 0;\n  cursor: nw-resize;\n  transform: rotate(180deg);\n}\n.react-grid-item > .react-resizable-handle.react-resizable-handle-ne {\n  top: 0;\n  right: 0;\n  cursor: ne-resize;\n  transform: rotate(270deg);\n}\n.react-grid-item > .react-resizable-handle.react-resizable-handle-w,\n.react-grid-item > .react-resizable-handle.react-resizable-handle-e {\n  top: 50%;\n  margin-top: -10px;\n  cursor: ew-resize;\n}\n.react-grid-item > .react-resizable-handle.react-resizable-handle-w {\n  left: 0;\n  transform: rotate(135deg);\n}\n.react-grid-item > .react-resizable-handle.react-resizable-handle-e {\n  right: 0;\n  transform: rotate(315deg);\n}\n.react-grid-item > .react-resizable-handle.react-resizable-handle-n,\n.react-grid-item > .react-resizable-handle.react-resizable-handle-s {\n  left: 50%;\n  margin-left: -10px;\n  cursor: ns-resize;\n}\n.react-grid-item > .react-resizable-handle.react-resizable-handle-n {\n  top: 0;\n  transform: rotate(225deg);\n}\n.react-grid-item > .react-resizable-handle.react-resizable-handle-s {\n  bottom: 0;\n  transform: rotate(45deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
